import { FC } from 'react';
import { toast } from 'sonner';
import { Typography, Button, Copy } from '@dreamteam-monorepo/ui';
import { BELeague } from '@/lib/leagueMappers';

interface LeagueSearchResultCardProps {
  league: BELeague;
  onJoin: () => void;
  joining?: boolean;
}

const Divider: FC = () => <hr className="border-t border-[--color-grey-200] w-full" />;

export const LeagueSearchResultCard: FC<LeagueSearchResultCardProps> = ({
  league,
  onJoin,
  joining = false,
}) => {
  const handleCopyCode = () => {
    navigator.clipboard.writeText(league.join_code).then(() => {
      toast.success('Code copied!');
    });
  };

  return (
    <div className="bg-white rounded-[--corner-md] p-[--padding-md] flex flex-col gap-[--padding-sm] shadow-[0px_4px_24px_0px_rgba(34,37,38,0.12)] w-full">
      {/* Name + badges */}
      <div className="flex flex-col gap-[--padding-sm]">
        <Typography
          as="h3"
          variant="headline025"
          className="text-[--color-neutral-900] !font-[900] truncate"
        >
          {league.name}
        </Typography>
        <div className="flex flex-wrap items-center gap-x-[--padding-md] gap-y-[--padding-2xs]">
          <span className="bg-[--color-grey-200] px-[--padding-xs] py-[--padding-3xs] rounded-[--corner-xs]">
            <Typography variant="label020" className="text-[--color-neutral-900]">
              {league.is_public ? 'Public' : 'Private'}
            </Typography>
          </span>
          <Typography variant="paragraph010" className="text-[--color-neutral-900]">
            Start: <span className="font-bold">GW {league.start_gameweek || 1}</span>
          </Typography>
        </div>
      </div>

      <Divider />

      {/* League code + copy */}
      <div className="flex items-center gap-[--padding-xs]">
        <Typography variant="paragraph010" className="flex-1 text-[--color-neutral-900]">
          League Code: <span className="font-bold">{league.join_code}</span>
        </Typography>
        <button
          type="button"
          onClick={handleCopyCode}
          className="flex items-center gap-2 shrink-0 text-[--color-blue-200]"
        >
          <Typography variant="button020" className="text-[--color-blue-200]">
            Copy Code
          </Typography>
          <Copy className="size-5" />
        </button>
      </div>

      <Divider />

      {/* Join button */}
      <div className="flex justify-end">
        <Button
          variant="contained"
          color="blue"
          size="small"
          onClick={onJoin}
          loading={joining}
          disabled={joining}
        >
          Join League
        </Button>
      </div>
    </div>
  );
};
